// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import VerticalLeftOutlinedSvg from "@fishx/icons-svg/es/asn/VerticalLeftOutlined";
import FishxIcon from '../components/FishxIcon';

var VerticalLeftOutlined = function VerticalLeftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: VerticalLeftOutlinedSvg
  }));
};

VerticalLeftOutlined.displayName = 'VerticalLeftOutlined';
export default React.forwardRef(VerticalLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/VerticalLeftOutlined.js
// module id = 4370
// module chunks = 0